/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import Select from "react-select";

import { SiteFieldProps } from "../../../types/rule";
import { getSelectStyles, SITE } from "../../../constant";
import { OptionTypeBase } from "../../../types/common";

const Site: FunctionComponent<SiteFieldProps> = ({
  disabled,
  id,
  parent,
  errors,
  siteIds,
  onValueChangeHandler,
  isDark,
  options,
}: SiteFieldProps) => {
  const { t } = useTranslation();
  const [allOptions, setAllOptions] = useState<OptionTypeBase[]>([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const dispatchNewValue = (data: string[]) => {
    onValueChangeHandler(
      {
        scope: "conditions",
        id,
        type: SITE,
        stringCollectionProperty: {
          property: "siteId",
          operator: "IN",
          values: data,
        },
      },
      parent
    );
  };

  const hasError = () => {
    return (
      errors?.find((item) => item.id === id && item.type === SITE) !== undefined
    );
  };

  useEffect(() => {
    if (options.length) {
      const final = [];
      options.forEach((op) => {
        op.options.forEach((opt) => {
          final.push(opt);
        });
      });
      setAllOptions(final);
    }
  }, [options]);

  useEffect(() => {
    if (allOptions.length > 0) {
      setSelectedOptions(
        allOptions.filter((item) => siteIds?.includes(item.value))
      );
    }
  }, [allOptions, siteIds]);

  return (
    <div className="row">
      <div className="col-md-4 col-xs-12 mb-1">
        <Select
          styles={getSelectStyles(isDark)}
          menuPlacement="auto"
          menuPosition="fixed"
          isDisabled={disabled}
          id={`${id}_operator`}
          isMulti
          name="operator"
          classNamePrefix="form-control-select"
          options={options}
          placeholder={t("select")}
          onChange={(selectedItems) => {
            dispatchNewValue(selectedItems.map((item) => item.value));
          }}
          value={selectedOptions}
        />
        {hasError() && (!siteIds || siteIds?.length == 0) && (
          <label
            className="validation-invalid-label"
            htmlFor={`${id}_hl7_field`}
          >
            {t("form:hl7.field_required")}
          </label>
        )}
      </div>
    </div>
  );
};

export default Site;
